import { render, staticRenderFns } from "./Interlinings.vue?vue&type=template&id=beed52c8&scoped=true"
import script from "./Interlinings.vue?vue&type=script&lang=js"
export * from "./Interlinings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beed52c8",
  null
  
)

export default component.exports